import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faHeart, faHome, faUser, faSearch } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartO, faHome as faHomeO, faUser as faUserO } from "@fortawesome/free-regular-svg-icons";

import classNames from "classnames";
import { faCartFlatbed, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { getWishListItems, loadCartItems } from "../../_helpers/cart.methods";
import { useAuthentication } from "../../../services/authentication/authentication.context";
import { useProduct } from "../../../services/products/product.context";
import { SearchForm } from "../forms/search-form";


export const SiteHeader = ({ pageTitle }) => {

    const { isAuthenticated } = useAuthentication();
    const { cart, wishList } = useProduct();
    const [language, setLanguage] = useState('fr');

    const isActive = (url) => {
        return window.location.pathname === url
    }

    const [cartquantity, setCartquantity] = useState(0);
    const [liked, setLiked] = useState(0);
    const [showSearchBar, setShowSearchBar] = useState(false);

    const handleSetLanguage = () => {
        if (language === 'en') {
            window.location.href = "/fr"
            localStorage.setItem('language', 'fr');
        } else {
            window.location.href = "/";
            localStorage.setItem('language', 'en');
        }
    }

    useEffect(() => {
        document.title = pageTitle;
        setCartquantity(cart?.length);
        setLiked(wishList?.length);

        //auto scroll upon page change
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        const lang = localStorage.getItem('language');
        if (lang === 'en') {
            window.location.href = "/";
        } else {
            return;
        }
    }, [pageTitle, cart, wishList])


    return (
        <header>
            {showSearchBar &&
                <SearchForm onClose={() => setShowSearchBar(false)} />
            }
            <div className="header-bar">
                <img src="/logos/logo.png" alt="" className="app-logo" />
                <div className="site-names">
                    <div className="site-name prim">KEVO</div>
                    <div className="site-name sec">TELECOM</div>
                </div>
                <button
                    className="tr-btn"
                    onClick={() => setShowSearchBar(true)}
                >
                    <FontAwesomeIcon className="s-icon" icon={faSearch} />
                </button>
                <button className="lang-button" onClick={handleSetLanguage}>
                    <span className="lang-label">
                        {language === 'en' ? 'Fr' : 'En'}
                    </span>
                    <img
                        src={language === 'en' ? "/logos/fr.png" : "/logos/en.png"}
                        alt=""
                        className="lang-img"
                    />
                </button>
            </div>
            <div className="nav-bar">
                <button
                    className={classNames('nav-button', { 'active': isActive('/fr') })}
                    onClick={() => window.location.href = "/fr"}
                >
                    <FontAwesomeIcon icon={isActive("/fr") ? faHome : faHomeO} />
                    <span className="button-label">Acceuille</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/fr/categories') })}
                    onClick={() => window.location.href = "/fr/categories"}
                >
                    <FontAwesomeIcon icon={faLayerGroup} />
                    <span className="button-label">Catégories</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/fr/wishlist') })}
                    onClick={() => window.location.href = "/fr/wishlist"}
                >
                    {liked > 0 &&
                        <div className="cart-quantity">
                            {liked}
                        </div>
                    }
                    <FontAwesomeIcon icon={isActive("/fr/wishlist") ? faHeart : faHeartO} />
                    <span className="button-label"> Liste d'envies</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/fr/cart') })}
                    onClick={() => window.location.href = "/fr/cart"}
                >
                    {cartquantity > 0 &&
                        <div className="cart-quantity">
                            {cartquantity}
                        </div>
                    }
                    <FontAwesomeIcon icon={faCartShopping} />
                    <span className="button-label">Panier</span>
                </button>
                <button
                    className={classNames('nav-button', { 'active': isActive('/fr/login') })}
                    onClick={() => {
                        isAuthenticated ? window.location.href = '/fr/admin' : window.location.href = "/fr/login"
                    }}
                >
                    <FontAwesomeIcon icon={isActive("/fr/login") ? faUser : faUserO} />
                    <span className="button-label">Compte</span>
                </button>

            </div>
        </header>
    )
}